<template>
  <div class="login-con" :style="{maxHeight:active?'100%':'0'}">
    <div class="login-mask" v-if="showClause"></div>
    <div class="user">
      <div class="user-btn" @click="logoutHandle">
        <vcenter>
          <i class="iconfont icon-geren"></i>
          <span>{{language==='en'?'Close':'关闭'}}</span>
        </vcenter>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li
          :class="{active:i === classActive}"
          @click="tabActive = item.id,classActive=i"
          v-for="(item,i) in tabs"
          :key="i"
        >{{language==='en'?item.enName:item.name}}</li>
      </ul>
      <component :is="tabActive" :active='active' :current='tabActive'></component>
    </div>
  </div>
</template>

<script>
import vcenter from '@/components/vcenter'
import ilogin from './ltemp/login'
import iregister from './ltemp/register'
import iforget from './ltemp/forget'
import ideviceLogin from './ltemp/deviceLogin'
import { mapState } from 'vuex'

export default {
  props: ['active'],
  components: {
    vcenter,
    ilogin,
    iregister,
    iforget,
    ideviceLogin
  },
  computed: {
    ...mapState({
      language: state => state.language.current,
      languagelAside: state => state.language.home.home.loginAside
    })
  },
  data () {
    let tabs = [
      {
        name: '用户登录',
        enName: 'User login',
        id: 'ilogin'
      },
      {
        name: '相机登录',
        enName: 'Camera login',
        id: 'ideviceLogin'
      }
    ]
    return {
      tabs,
      tabActive: 'ilogin',
      classActive: 0,
      showClause: false
    }
  },
  methods: {
    logoutHandle () {
      this.$bus.$emit('hideAside')
      setTimeout(() => {
        this.tabs = [
          {
            name: '用户登录',
            enName: 'User login',
            id: 'ilogin'
          },
          {
            name: '相机登录',
            enName: 'Camera login',
            id: 'ideviceLogin'
          }
        ]
        this.tabActive = 'ilogin'
        this.classActive = 0
      }, 700)
    }
  },
  mounted () {
    this.$bus.$on('openClause', data => {
      this.showClause = data.show
    })

    this.$bus.$on('changName', data => {
      this.tabs[0] = data
      this.tabActive = data.id
    })
    this.$bus.$on('currentActive', data => {
      this.tabActive = data || 'ilogin'
      this.tabs = [
        {
          name: '用户登录',
          enName: 'User login',
          id: 'ilogin'
        },
        {
          name: '相机登录',
          enName: 'Camera login',
          id: 'ideviceLogin'
        }
      ]
      this.classActive = 0
    })
  }
}
</script>

<style lang="scss" scoped>
.login-con {
  $animateType: cubic-bezier(0.77, 0, 0.175, 1);

  position: fixed;
  right: 0;
  height: 100%;
  transition: max-height 0.7s $animateType;
  max-height: 100%;
  background: #232326;
  z-index: 99999;
  top: 0;
  overflow: hidden;
  .login-mask{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    background: rgba($color: #000000, $alpha: 0);
  }
  .user {
    background: #fff;
    height: 68px;
    .user-btn {
      cursor: pointer;
      float: right;
      background-color: #000;
      color: #fff;
      height: 68px;
      width: 120px;
      text-align: center;
      box-sizing: border-box;
      i {
        font-size: 24px;
        vertical-align: middle;
      }

      span {
        font-size: 16px;
        margin-left: 4px;
        font-weight: bold;
        vertical-align: middle;
      }
    }
  }
  .tab {
    ul {
      background-color: #fff;
      padding-right: 120px;
      li {
        display: inline-block;
        color: #a1a1a1;
        background-color: #fff;
        line-height: 70px;
        text-align: center;
        height: 70px;
        font-size: 18px;
        cursor: pointer;
        width: 165px;
        &:last-child {
          border-left: 1px solid #ededed;
        }
        &:first-child {
          border-right: 1px solid #ededed;
        }
      }
      .active {
        color: #fff;
        background-color: #232326;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/layout/aside/temp/login.vue